import { createBrowserRouter } from 'react-router-dom'
import { exposeFrameNavigator } from './helpers/atlasModuleFrame'
import { createAppRoutes } from './routes'

/**
 * The app's router instance.
 *
 * Lives in its own module rather than in app.tsx so components mounted *outside*
 * `RouterProvider` — the app-level overlays like MessageToasts — can navigate
 * imperatively via `router.navigate()`. Importing it from app.tsx would be a cycle,
 * since app.tsx renders those same overlays.
 */
export const router = createBrowserRouter(createAppRoutes())

exposeFrameNavigator((path, options) => router.navigate(path, options))
